import React from 'react';
import ContainerTemplate from '../../../widgets/template/Container';
import TorneosView from './TorneosView';
import * as ROUTES from '../../../router/Routes';

const TorneosModule = () => {
  return (
    <ContainerTemplate
      active={ROUTES.torneos}
      routes={[ROUTES.juegosDeportivos]}
    >
      <TorneosView />
    </ContainerTemplate>
  );
};

export default TorneosModule;
